import React from 'react';
import { motion } from 'framer-motion';

const HeroOverlay = ({ onExplore }) => (
  <motion.div
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    exit={{ opacity: 0 }}
    transition={{ duration: 0.6 }}
    className="absolute inset-0 z-20 flex items-center justify-center"
  >
    <div className="absolute inset-0 bg-opacity-20-important" />

    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -30 }}
      transition={{ duration: 0.8 }}
      className="relative z-10 text-center px-8 py-12 max-w-2xl mx-4"
    >
      <div className="mb-8 flex justify-center">
        <img src="/images/Kanors_logo.png" alt="KANORS Logo" className="h-16" />
      </div>

      <h1 className="text-5xl md:text-6xl font-bold text-blue-800 mb-6">VERVESTACKS</h1>

      <p className="text-lg text-gray-700 mb-10 max-w-xl mx-auto">
        A comprehensive Python project for processing global energy data and building energy models.
      </p>

      <button
        onClick={onExplore}
        className="bg-gradient-to-r from-orange-400 via-pink-400 to-red-400 text-white px-10 py-4 rounded-xl font-bold flex items-center space-x-3 mx-auto"
      >
        <span>Explore</span>
      </button>
    </motion.div>
  </motion.div>
);

export default React.memo(HeroOverlay);
